import React from 'react';

import { useRecoilValue } from 'recoil';

import { blockDisplayHeader, customizedBlock } from 'venn-state';

import { Block } from '../../components/core';

interface PortfolioComparisonHeaderProps {
  id: string;
}

export const PortfolioComparisonHeader = ({ id }: PortfolioComparisonHeaderProps) => {
  const title = useRecoilValue(blockDisplayHeader(id));
  const { subHeader } = useRecoilValue(customizedBlock(id));

  return (
    <Block.HeaderTopContainer id={id}>
      <Block.Title>
        <Block.Headline id={id}>{title}</Block.Headline>
        {subHeader && <Block.SubHeadline id={id}>{subHeader}</Block.SubHeadline>}
      </Block.Title>
    </Block.HeaderTopContainer>
  );
};
